/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: bdb92e282dcf
 */

import { streamingProfilesCreateStreamingProfile } from "../../funcs/streamingProfilesCreateStreamingProfile.js";
import { StreamingProfileCreate$zodSchema } from "../../models/streamingprofilecreate.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: StreamingProfileCreate$zodSchema.describe(
    `The streaming profile configuration.`,
  ),
};

export const tool$streamingProfilesCreateStreamingProfile: ToolDefinition<
  typeof args
> = {
  name: "create-streaming-profile",
  description:
    `Creates a new adaptive streaming profile in your Cloudinary account`,
  scopes: ["builder"],
  annotations: {
    "title": "Create Streaming Profile",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await streamingProfilesCreateStreamingProfile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
